import { render, staticRenderFns } from "./PurchaseOrderLineItemColumns.vue?vue&type=template&id=27e20c58&scoped=true"
import script from "./PurchaseOrderLineItemColumns.vue?vue&type=script&lang=ts"
export * from "./PurchaseOrderLineItemColumns.vue?vue&type=script&lang=ts"
import style0 from "./PurchaseOrderLineItemColumns.vue?vue&type=style&index=0&id=27e20c58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e20c58",
  null
  
)

export default component.exports